export function pageLayout() {
	// intentionally blank, all plugin files are pulled from confluence via WRM
}

export function pageLayoutWRM() {
	return ['wr!com.atlassian.confluence.plugins.confluence-page-layout:pagelayout-frontend'];
}
